export * from './feature-details.component';
export * from './feature-details-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/feature-details/index.ts